// extracted by mini-css-extract-plugin
export default {"form":"styles_form__VN94r","container":"styles_container__hw82i"};